import React, { useCallback, useEffect, useRef, useState } from "react";
import BreadCrumbComp from "../../components/breadCrumb";
import LoadingFeedback, { useLoadingState } from "../../components/loadingFeedback";
import FormTextField from "../../components/textField/formTextField";
import { Grid, useMediaQuery } from "@mui/material";
import { useForm } from "react-hook-form";
import InspectionProtocol from "./technicalInspectionComponents/inspectionProtocol";
import AnnexesPhotographicEvidence from "./technicalInspectionComponents/AnnexesPhotographicEvidence";
import ElectronicSignature from "./technicalInspectionComponents/electronicSignature";
import LaddaButton from "../../components/buttons/laddaButton";
import {
  callActionApiAsync,
  generateTechnicalInspectionActPDF,
  getCallBioEquipmentById,
  getInspectionRecordAdditionalImages,
  insertInspectionRecordAdditionalImages,
  postRespondInspectionRecord,
  postSaveInspectionRecord
} from "../../services/apiService";
import { useDispatch, useSelector } from "react-redux";
import { hasAnyRoleUtil } from "../../utils/AuthorizedUtils/360Report";
import ModalComponent from "../../components/modals";
import DeclineInspectionRecordModal from "./technicalInspectionComponents/declineInspectionRecordModal";
import { inspectionRecordProcess } from "../../constants/enums";
import { useLocation, useNavigate } from "react-router-dom";
import ToastNotification from "../../components/toastNotification";
import HeaderBanner from "../../components/headerBanner";
import { headerBannerType } from "../../constants/enums";
import {
  BIOMEDICAL_INSPECTION_APPROVE_ROLES,
  BIOMEDICAL_INSPECTION_EDIT_ROLES
} from "../../constants/biomedicalRoles";

const urlApi = process.env.REACT_APP_API_URL;

const normalizeSignatureSource = (value) => {
  if (!value) return null;
  const source = String(value);
  if (source.startsWith("data:image") || source.startsWith("http")) {
    return source;
  }
  const normalizedPath = source.replace(/\\/g, "/");
  return `${urlApi}/${normalizedPath}`;
};

const NewTechnicalInspectionAct = () => {
  const [loadingDetails, setLoadingDetails] = useLoadingState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const userData = useSelector((state) => state.userData.userData);
  const bioEquipmentId = useSelector((state) => state.biomedical.biomedicalId);
  const requestedInspectionRecordId = Number.parseInt(
    new URLSearchParams(location.search).get("inspectionRecordId"),
    10
  );
  const selectedInspectionRecordId = Number.isFinite(
    requestedInspectionRecordId
  )
    ? requestedInspectionRecordId
    : null;
  const canApproveInspection = hasAnyRoleUtil(
    BIOMEDICAL_INSPECTION_APPROVE_ROLES,
    userData.roleList
  );
  const canEditInspection = hasAnyRoleUtil(
    BIOMEDICAL_INSPECTION_EDIT_ROLES,
    userData.roleList
  );
  const canCreateAndApprove = canApproveInspection && canEditInspection;
  const isApprover = canApproveInspection && !canEditInspection;
  const isBiomedicalCreator = canEditInspection;
  const isViewer = !canEditInspection && !canApproveInspection;

  var canEdit = canEditInspection && !canApproveInspection;

  const [openDeclineModal, setOpenDeclineModal] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [signature, setSignature] = useState(null);
  const [inspectionTitle, setInspectionTitle] = useState(
    "CREAR NUEVA ACTA DE INSPECCIÓN TÉCNICA EQUIPOS BIOMÉDICOS"
  );
  const [loadDataState, setLoadDataState] = useState({});
  const [protocolValidation, setProtocolValidation] = useState({
    isLoading: true,
    hasRows: false,
    isComplete: false,
    rows: []
  });
  const [images, setImages] = useState({
    image1: { file: null, description: "", path: null, id: 0, isNew: false },
    image2: { file: null, description: "", path: null, id: 0 },
    image3: { file: null, description: "", path: null, id: 0 },
    image4: { file: null, description: "", path: null, id: 0 }
  });
  const [notificationDataModal, setNotificationDataModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [isSavingInspection, setIsSavingInspection] = useState(false);
  const [isApprovingInspection, setIsApprovingInspection] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "warning",
    summary: "",
    detail: ""
  });
  const showInspectionError = useCallback((error, summary, fallback) => {
    setToastConfig({
      severity: "error",
      summary,
      detail: typeof error === "string" && error ? error : fallback
    });
    setShowToast(true);
  }, []);
  const [approverSignature, setApproverSignature] = useState("");
  const [approverData, setApproverData] = useState({});
  const [additionalImages, setAdditionalImages] = useState([]);
  const [elaboratorSignatureData, setElaboratorSignatureData] = useState(null);
  const saveInFlightRef = useRef(false);
  const approveInFlightRef = useRef(false);
  const generatePDFInFlightRef = useRef(false);
  const protectedActionRef = useRef(null);
  const [activeAction, setActiveAction] = useState(null);
  const isPageBusy = !!activeAction || isSavingInspection || isApprovingInspection;
  const startProtectedAction = (action) => {
    if (protectedActionRef.current !== null || isSavingInspection || isApprovingInspection) return false;
    protectedActionRef.current = action;
    setActiveAction(action);
    return true;
  };
  const endProtectedAction = () => {
    protectedActionRef.current = null;
    setActiveAction(null);
  };

  const handleSaveSubmit = async (event) => {
    event.preventDefault();
    if (!startProtectedAction("save")) return;
    setIsSavingInspection(true);
    try {
      await handleSubmit(onSubmit)(event);
    } catch (error) {
      showInspectionError(error, "Error al guardar", "No se pudo guardar el acta de inspección. Intenta nuevamente.");
    } finally {
      setIsSavingInspection(false);
      endProtectedAction();
    }
  };

  const handleReturn = () => {
    if (!startProtectedAction("navigate")) return;
    navigate("/biomedicalManagementDashboard/manageDevice");
  };

  const openRejectConfirmation = () => {
    if (!startProtectedAction("rejectConfirmation")) return;
    setOpenDeclineModal(true);
  };
  const startRejection = () => {
    if (protectedActionRef.current !== "rejectConfirmation") return false;
    protectedActionRef.current = "reject";
    setActiveAction("reject");
    return true;
  };
  const endRejection = () => {
    if (protectedActionRef.current !== "reject") return;
    protectedActionRef.current = "rejectConfirmation";
    setActiveAction("rejectConfirmation");
  };
  const imageProcessingRef = useRef(false);
  const [imageProcessing, setImageProcessing] = useState(false);
  const [imagesLoading, setImagesLoading] = useState(true);
  const [additionalImagesLoading, setAdditionalImagesLoading] = useState(false);
  const isInspectionLocked = isEditable;

  const isSmallScreen = useMediaQuery("(max-width:590px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");
  const isAndroid = /Android/i.test(navigator.userAgent);

  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue
  } = useForm({
    mode: "all"
  });

  const { control: notificationControl, setValue: notificationSetValue } =
    useForm({
      defaultValues: {
        coment: ""
      }
    });

  const handleCloseDeclineModal = () => {
    if (protectedActionRef.current !== "rejectConfirmation") return;
    setOpenDeclineModal(false);
    endProtectedAction();
  };

  const loadAdditionalImages = async (inspectionRecordId) => {
    console.log("Ejecutando loadAdditionalImages:", inspectionRecordId);

    if (!inspectionRecordId || Number(inspectionRecordId) === 0) {
      setAdditionalImages([]);
      return;
    }

    const cacheBust = Date.now();

    await callActionApiAsync(
      () => getInspectionRecordAdditionalImages(inspectionRecordId, cacheBust),
      (data) => {
        console.log("Data imágenes adicionales:", data);

        const mappedImages = Array.isArray(data)
          ? data.map((image) => {
              const correctedPath = image.path
                ? image.path.replace(/\\/g, "/")
                : null;

              return {
                id: image.relationId,
                relationId: image.relationId,
                imageId: image.imageId,
                file: null,
                path: correctedPath ? `${urlApi}/${correctedPath}` : null,
                description: image.description || "",
                isNew: false
              };
            })
          : [];

        console.log("Mapped imágenes adicionales:", mappedImages);

        setAdditionalImages(mappedImages);
      },
      (error) => showInspectionError(error, "Error al cargar evidencias", "No se pudieron cargar las evidencias del acta."),
      (active) => { setLoadingDetails(active); setAdditionalImagesLoading(active); }
    );
  };

  const saveAdditionalImages = async (inspectionRecordId) => {
    if (!inspectionRecordId || Number(inspectionRecordId) === 0) return false;

    const newAdditionalImages = additionalImages.filter((image) => {
      return image.file && image.isNew;
    });

    if (newAdditionalImages.length === 0) return true;

    const formData = new FormData();
    formData.append("requestId", crypto.randomUUID());
    formData.append("userId", userData.id);

    newAdditionalImages.forEach((image) => {
      formData.append("additionalImages", image.file);
      formData.append("additionalDescriptions", image.description || "");
    });

    let saved = false;
    await callActionApiAsync(
      () =>
        insertInspectionRecordAdditionalImages(formData, inspectionRecordId),
      async () => {
        saved = true;
        await loadAdditionalImages(inspectionRecordId);
      },
      (error) => showInspectionError(
        null,
        "Evidencias sin guardar",
        `El acta se guardó, pero no se pudieron guardar las evidencias adicionales. ${typeof error === "string" && error ? error : "Intenta nuevamente."}`
      )
    );
    return saved;
  };

  const getBioEquipmentById = async () => {
    await callActionApiAsync(
      () =>
        getCallBioEquipmentById(
          bioEquipmentId,
          userData.id,
          selectedInspectionRecordId
        ),
      async (data) => {
        setLoadDataState(data);

        if (data.inspectionName) {
          setInspectionTitle(
            "ACTA DE INSPECCIÓN TÉCNICA EQUIPOS BIOMÉDICOS " +
              data.inspectionName
          );
        } else {
          setInspectionTitle(
            "CREAR NUEVA ACTA DE INSPECCIÓN TÉCNICA EQUIPOS BIOMÉDICOS"
          );
        }

        await loadData(data);
        notificationSetValue("coment", data.comments);
      },
      (error) => showInspectionError(error, "Error al cargar el acta", "No se pudo actualizar la información del acta. Recarga la página."),
      (active) => {
        setIsSavingInspection(active);
        setLoadingDetails(active);
        setImagesLoading(active);
      }
    );
  };

  const getTextApprovation = () => {
    if (inspectionRecordProcess.pending == loadDataState.state)
      return "Rechazado";
    if (inspectionRecordProcess.sent == loadDataState.state)
      return "Pendiente de Aprobacion";
    if (inspectionRecordProcess.approved == loadDataState.state)
      return "Aprobado";
    return "Pendiente de Aprobacion";
  };

  const loadData = async (inspectionActData) => {
    setIsEditable(
      inspectionActData.state == inspectionRecordProcess.sent ||
        inspectionActData.state == inspectionRecordProcess.approved
    );

    setValue("equipment", inspectionActData.name);
    setValue("actBranch", inspectionActData.brandName);
    setValue("model", inspectionActData.model);
    setValue("serie", inspectionActData.serieName);
    setValue(
      "importDeclaration",
      inspectionActData.importDeclaration
        ? inspectionActData.importDeclaration
        : ""
    );
    setValue("observations", inspectionActData.observations);

    const hasElaboratorSystemSignature = Boolean(
      inspectionActData.elaboratorSignature
    );

    setElaboratorSignatureData(
      hasElaboratorSystemSignature
        ? {
            id: inspectionActData.elaboratorSignatureId,
            signature: normalizeSignatureSource(
              inspectionActData.elaboratorSignature
            )
          }
        : null
    );

    setSignature(
      hasElaboratorSystemSignature
        ? normalizeSignatureSource(inspectionActData.elaboratorSignature)
        : normalizeSignatureSource(inspectionActData.signature)
    );

    let finalImageUrl1 = "";
    let finalImageUrl2 = "";
    let finalImageUrl3 = "";
    let finalImageUrl4 = "";

    if (inspectionActData.path1) {
      const correctedImagePath1 = inspectionActData.path1.replace(/\\/g, "/");
      finalImageUrl1 = `${urlApi}/${correctedImagePath1}`;
    }

    if (inspectionActData.path2) {
      const correctedImagePath2 = inspectionActData.path2.replace(/\\/g, "/");
      finalImageUrl2 = `${urlApi}/${correctedImagePath2}`;
    }

    if (inspectionActData.path3) {
      const correctedImagePath3 = inspectionActData.path3.replace(/\\/g, "/");
      finalImageUrl3 = `${urlApi}/${correctedImagePath3}`;
    }

    if (inspectionActData.path4) {
      const correctedImagePath4 = inspectionActData.path4.replace(/\\/g, "/");
      finalImageUrl4 = `${urlApi}/${correctedImagePath4}`;
    }

    setImages({
      image1: {
        file: null,
        path: inspectionActData.path1 ? finalImageUrl1 : null,
        description: inspectionActData.description1 || ""
      },
      image2: {
        file: null,
        path: inspectionActData.path2 ? finalImageUrl2 : null,
        description: inspectionActData.description2 || ""
      },
      image3: {
        file: null,
        path: inspectionActData.path3 ? finalImageUrl3 : null,
        description: inspectionActData.description3 || ""
      },
      image4: {
        file: null,
        path: inspectionActData.path4 ? finalImageUrl4 : null,
        description: inspectionActData.description4 || ""
      }
    });

    setApproverSignature(
      normalizeSignatureSource(inspectionActData.approverSignature) || ""
    );

    setApproverData({
      approverUserName: inspectionActData.approverUserName,
      approverPositionName: inspectionActData.approverPositionName
    });

    if (inspectionActData.inspectionRecordId) {
      await loadAdditionalImages(inspectionActData.inspectionRecordId);
    } else {
      setAdditionalImages([]);
    }
  };

  useEffect(() => {
    getBioEquipmentById();
  }, [bioEquipmentId, selectedInspectionRecordId, setValue]);

  const validateProtocol = (action) => {
    if (protocolValidation.isLoading) {
      showInspectionError(null, "Protocolo cargando", "Espera a que termine de cargar el protocolo de inspección.");
      return false;
    }
    if (!protocolValidation.hasRows) {
      showInspectionError(null, "Protocolo obligatorio", `El equipo no tiene un protocolo de inspección. Debes configurar al menos una actividad antes de ${action} el acta.`);
      return false;
    }
    if (!protocolValidation.isComplete) {
      showInspectionError(null, "Protocolo incompleto", `Todas las actividades del protocolo de inspección deben tener un estado seleccionado antes de ${action}.`);
      return false;
    }
    return true;
  };

  const onSubmit = async () => {
    if (imageProcessingRef.current) return;
    if (!validateProtocol("guardar")) return;

    const hasElaboratorSystemSignature = Boolean(
      elaboratorSignatureData?.signature
    );

    if (signature == null && !hasElaboratorSystemSignature) {
      setToastConfig({
        severity: "error",
        summary: "Error al cargar firma",
        detail: "Debes guardar la firma antes de guardar el acta."
      });
      setShowToast(true);
      return;
    }

    const formData = new FormData();
    formData.append("requestId", crypto.randomUUID());
    if (images.image1.file || images.image1.path == null) {
      formData.append("delete1", true);
    } else {
      formData.append("delete1", false);
    }
    if (images.image2.file || images.image2.path == null) {
      formData.append("delete2", true);
    } else {
      formData.append("delete2", false);
    }
    if (images.image3.file || images.image3.path == null) {
      formData.append("delete3", true);
    } else {
      formData.append("delete3", false);
    }
    if (images.image4.file || images.image4.path == null) {
      formData.append("delete4", true);
    } else {
      formData.append("delete4", false);
    }

    if (images.image1.path && images.image1.file != null) {
      formData.append("image1", images.image1.file);
    }
    if (images.image2.path && images.image2.file != null) {
      formData.append("image2", images.image2.file);
    }
    if (images.image3.path && images.image3.file != null) {
      formData.append("image3", images.image3.file);
    }
    if (images.image4.path && images.image4.file != null) {
      formData.append("image4", images.image4.file);
    }

    const observations = getValues("observations") || "";

    formData.append("description1", images.image1.description);
    formData.append("description2", images.image2.description);
    formData.append("description3", images.image3.description);
    formData.append("description4", images.image4.description);
    formData.append("biomedical_equipment_id", bioEquipmentId);
    formData.append(
      "signature",
      signature || elaboratorSignatureData?.signature || ""
    );
    formData.append("userId", userData.id);
    formData.append("observations", observations);
    formData.append("importDeclaration", getValues("importDeclaration"));
    formData.append(
      "inspectionRecordId",
      loadDataState.inspectionRecordId == null
        ? 0
        : loadDataState.inspectionRecordId
    );
    await callActionApiAsync(
      () => postSaveInspectionRecord(formData),
      async (data) => {
        const finalInspectionRecordId =
          data?.inspectionRecordId || loadDataState.inspectionRecordId;

        setLoadDataState((current) => ({ ...current, inspectionRecordId: finalInspectionRecordId }));
        if (!await saveAdditionalImages(finalInspectionRecordId)) return;

        setToastConfig({
          severity: "success",
          summary: "Acta guardada",
          detail: "Acta de inspección guardada y enviada a aprobación correctamente."
        });
        setShowToast(true);
        await getBioEquipmentById();
      },
      (error) => showInspectionError(error, "Error al guardar", "No se pudo guardar el acta de inspección. Intenta nuevamente.")
    );
  };

  const generatePDF = async () => {
    if (!startProtectedAction("pdf")) return;
    try {
      await generatePDFCore();
    } catch (error) {
      showInspectionError(error, "Error al generar PDF", "No se pudo generar el PDF del acta.");
    } finally {
      endProtectedAction();
    }
  };

  const generatePDFCore = async () => {
    const currentInspectionRecordId =
      loadDataState.inspectionRecordId || selectedInspectionRecordId;

    await callActionApiAsync(
      () =>
        generateTechnicalInspectionActPDF(
          bioEquipmentId,
          currentInspectionRecordId,
          { requestId: crypto.randomUUID(), userId: userData.id }
        ),
      (data) => {
        if (data?.path) {
          const cleanedPath = data.path.replace(/\\/g, "/");
          const fullUrl = `${urlApi}${cleanedPath}`;
          if (isAndroid) {
            console.log("Android detected, opening in new tab:", fullUrl);
            window.open(fullUrl, "_blank");
          } else {
            console.log("Not Android, triggering download:", fullUrl);
            const link = document.createElement("a");
            link.href = fullUrl;
            link.download = "reporte.pdf";
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      },
      (error) => showInspectionError(error, "Error al generar PDF", "No se pudo generar el PDF del acta.")
    );
  };

  const onSubmitAnswer = async () => {
    if (!startProtectedAction("approve")) return;
    setIsApprovingInspection(true);
    try {
      await approveInspection();
    } catch (error) {
      showInspectionError(error, "Error de aprobación", "No se pudo aprobar el acta de inspección.");
    } finally {
      setIsApprovingInspection(false);
      endProtectedAction();
    }
  };

  const approveInspection = async () => {
    if (!validateProtocol("aprobar")) return;

    const objToSend = {
      requestId: crypto.randomUUID(),
      biomadicalEquipmentId: bioEquipmentId,
      inspectionRecordId: loadDataState.inspectionRecordId,
      state: inspectionRecordProcess.approved,
      approverSignature: "",
      userId: userData.id
    };
    await callActionApiAsync(
      () => postRespondInspectionRecord(objToSend),
      async () => {
        setToastConfig({
          severity: "success",
          summary: "Aprobación",
          detail: "Inspección técnica aprobada correctamente."
        });
        setShowToast(true);
        await getBioEquipmentById();
      },
      (error) => showInspectionError(error, "Error de aprobación", "No se pudo aprobar el acta de inspección.")
    );
  };

  return (
    <div>
      <div inert={isPageBusy ? "" : undefined}><BreadCrumbComp /></div>
      <HeaderBanner type={headerBannerType.inspectionReport} />
      <div className="create-form-container">
        <fieldset disabled={isPageBusy} inert={isPageBusy ? "" : undefined}
          style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
        <div className="HContainer j-space-between mv-25 a-center">
          <p className="createRist-title ml-0">{inspectionTitle}</p>
          {loadDataState.comments && (
            <LaddaButton
              width={"160px"}
              fontSize={"12px"}
              height={"40px"}
              variant="contained"
              backgroundColor={"#FFA500"}
              disabled={isPageBusy}
              onClick={() => {
                if (!startProtectedAction("comment")) return;
                notificationSetValue("coment", loadDataState.comments);
                setNotificationDataModal(true);
              }}
            >
              <p className="button_text">Comentario</p>
            </LaddaButton>
          )}
        </div>

        <p className="createRist-title mt-25 ml-0">1. Tecnología Médica</p>
        <LoadingFeedback loading={loadingDetails} rows={8}>
        <form onSubmit={handleSaveSubmit}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} md={6}>
              <p className="create-label ml-0">Equipo:</p>
              <FormTextField
                name="equipment"
                control={control}
                label=""
                error={errors.equipment}
                disabled
                margin={"0"}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <p className="create-label ml-0">Marca:</p>
              <FormTextField
                name="actBranch"
                control={control}
                label=""
                error={errors.actBranch}
                disabled
                margin={"0"}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <p className="create-label ml-0">Modelo:</p>
              <FormTextField
                name="model"
                control={control}
                label=""
                error={errors.model}
                disabled
                margin={"0"}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <p className="create-label ml-0">Serie:</p>
              <FormTextField
                name="serie"
                control={control}
                label=""
                error={errors.serie}
                disabled
                margin={"0"}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <p className="create-label ml-0">Declaración de Importación:</p>
              <FormTextField
                name="importDeclaration"
                control={control}
                label=""
                error={errors.importDeclaration}
                disabled={
                  isInspectionLocked ||
                  ((!canEdit &&
                    !canCreateAndApprove) ||
                    isViewer)
                }
                margin={"0"}
              />
            </Grid>
            <Grid item xs={12} md={6}></Grid>
          </Grid>

          <InspectionProtocol
            onError={showInspectionError}
            userId={userData.id}
            startProtectedAction={startProtectedAction}
            endProtectedAction={endProtectedAction}
            bioEquipmentId={bioEquipmentId}
            onProtocolValidationChange={setProtocolValidation}
            isApprover={
              isApprover &&
              !isBiomedicalCreator &&
              !canCreateAndApprove
            }
            isViewer={isViewer}
            isLocked={isInspectionLocked}
          />

          <AnnexesPhotographicEvidence
            startProtectedAction={startProtectedAction}
            endProtectedAction={endProtectedAction}
            isBusy={imageProcessing || isSavingInspection}
            imagesLoading={imagesLoading || additionalImagesLoading || isSavingInspection}
            onProcessingChange={(busy) => {
              if (busy && imageProcessingRef.current) return false;
              imageProcessingRef.current = busy; setImageProcessing(busy); return true;
            }}
            images={images}
            setImages={setImages}
            additionalImages={additionalImages}
            setAdditionalImages={setAdditionalImages}
            isApprover={
              isApprover &&
              !isBiomedicalCreator &&
              !canCreateAndApprove
            }
            isViewer={isViewer}
            isLocked={isInspectionLocked}
          />

          <div className="page-break">
            <p className="createRist-title mt-25">4. Observaciones</p>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} md={12}>
                <p className="create-label ml-0">Observaciones:</p>
                <FormTextField
                  name="observations"
                  control={control}
                  label=""
                  isTextArea={true}
                  error={errors.observations}
                  maxLength={500}
                  margin={"0"}
                  disabled={
                    isInspectionLocked ||
                    ((isApprover &&
                      !isBiomedicalCreator &&
                      !canCreateAndApprove) ||
                      isViewer)
                  }
                />
              </Grid>
            </Grid>
          </div>

          <ElectronicSignature
            setSignature={setSignature}
            base64Signature={signature}
            elaboratorSignatureData={elaboratorSignatureData}
            elaboratorName={loadDataState.userName}
            elaboratorPosition={loadDataState.positionName}
            approverSignature={approverSignature}
            approverName={approverData.approverUserName}
            approverPosition={approverData.approverPositionName}
            approvalText={getTextApprovation()}
            isApprover={
              isApprover &&
              !isBiomedicalCreator &&
              !canCreateAndApprove
            }
            isViewer={isViewer}
            isLocked={isInspectionLocked}
          />

          <div
            className="HContainer j-center technical-inspection-action-row"
            style={{ marginTop: "80px", marginBottom: "32px" }}
          >
            {isApprover &&
              !isBiomedicalCreator &&
              inspectionRecordProcess.sent == loadDataState.state && (
                <div className="HContainer technical-inspection-actions">
                  <LaddaButton
                    width={"160px"}
                    fontSize={"12px"}
                    height={"40px"}
                    variant="contained"
                    disabled={isPageBusy}
                    loading={activeAction === "approve"}
                    backgroundColor={"#6A6AD8"}
                    onClick={onSubmitAnswer}
                  >
                    <p className="button_text">Aprobar</p>
                  </LaddaButton>
                  <LaddaButton
                    width={"160px"}
                    fontSize={"12px"}
                    height={"40px"}
                    variant="contained"
                    backgroundColor={"#F43F5E"}
                    disabled={isPageBusy}
                    onClick={openRejectConfirmation}
                  >
                    <p className="button_text">Rechazar</p>
                  </LaddaButton>
                </div>
              )}
            {!canCreateAndApprove && !isApprover && isBiomedicalCreator && (
              <div className="HContainer no-print technical-inspection-actions">
                <LaddaButton
                  variant="contained"
                  color={"#404040"}
                  backgroundColor={"#F4D658"}
                  disabled={isPageBusy}
                  loading={activeAction === "pdf"}
                  onClick={generatePDF}
                >
                  <div className="HContainer align-center">
                    <p className="button_text">Crear PDF</p>
                  </div>
                </LaddaButton>
                {!isEditable ? (
                  <>
                    <LaddaButton
                      width={"160px"}
                      fontSize={"12px"}
                      height={"40px"}
                      variant="contained"
                      type="submit"
                      disabled={isPageBusy || imageProcessing}
                      loading={activeAction === "save"}
                    >
                      <p className="button_text">Guardar</p>
                    </LaddaButton>
                  </>
                ) : (
                  <>
                    <LaddaButton
                      width={"160px"}
                      fontSize={"12px"}
                      height={"40px"}
                      variant="contained"
                      disabled={isPageBusy}
                      onClick={handleReturn}
                    >
                      <p className="button_text">Volver</p>
                    </LaddaButton>
                  </>
                )}
              </div>
            )}
            {canCreateAndApprove && (
              <div className="HContainer no-print technical-inspection-actions">
                {loadDataState.state !== inspectionRecordProcess.approved ? (
                  <>
                    <LaddaButton
                      variant="contained"
                      color={"#404040"}
                      backgroundColor={"#F4D658"}
                      disabled={isPageBusy}
                      loading={activeAction === "pdf"}
                      onClick={generatePDF}
                    >
                      <div className="HContainer align-center">
                        <p className="button_text">Crear PDF</p>
                      </div>
                    </LaddaButton>
                    {!isEditable ? (
                      <>
                        <LaddaButton
                          width={"160px"}
                          fontSize={"12px"}
                          height={"40px"}
                          variant="contained"
                          type="submit"
                          disabled={isPageBusy || imageProcessing}
                          loading={activeAction === "save"}
                        >
                          <p className="button_text">Guardar</p>
                        </LaddaButton>
                      </>
                    ) : (
                      <>
                        <LaddaButton
                          width={"160px"}
                          fontSize={"12px"}
                          height={"40px"}
                          variant="contained"
                          disabled={isPageBusy}
                          onClick={handleReturn}
                        >
                          <p className="button_text">Volver</p>
                        </LaddaButton>
                        <LaddaButton
                          width={"160px"}
                          fontSize={"12px"}
                          height={"40px"}
                          variant="contained"
                          disabled={isPageBusy}
                          loading={activeAction === "approve"}
                          backgroundColor={"#6A6AD8"}
                          onClick={onSubmitAnswer}
                        >
                          <p className="button_text">Aprobar</p>
                        </LaddaButton>
                        <LaddaButton
                          width={"160px"}
                          fontSize={"12px"}
                          height={"40px"}
                          variant="contained"
                          backgroundColor={"#F43F5E"}
                          disabled={isPageBusy}
                          onClick={openRejectConfirmation}
                        >
                          <p className="button_text">Rechazar</p>
                        </LaddaButton>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <LaddaButton
                      variant="contained"
                      color={"#404040"}
                      backgroundColor={"#F4D658"}
                      disabled={isPageBusy}
                      loading={activeAction === "pdf"}
                      onClick={generatePDF}
                    >
                      <div className="HContainer align-center">
                        <p className="button_text">Crear PDF</p>
                      </div>
                    </LaddaButton>
                    <LaddaButton
                      width={"160px"}
                      fontSize={"12px"}
                      height={"40px"}
                      variant="contained"
                      disabled={isPageBusy}
                      onClick={handleReturn}
                    >
                      <p className="button_text">Volver</p>
                    </LaddaButton>
                  </>
                )}
              </div>
            )}

            {isViewer && (
              <div className="HContainer no-print technical-inspection-actions">
                <LaddaButton
                  variant="contained"
                  color={"#404040"}
                  backgroundColor={"#F4D658"}
                  disabled={isPageBusy}
                  loading={activeAction === "pdf"}
                  onClick={generatePDF}
                >
                  <div className="HContainer align-center">
                    <p className="button_text">Crear PDF</p>
                  </div>
                </LaddaButton>
              </div>
            )}
          </div>
        </form>
        </LoadingFeedback>
        </fieldset>
      </div>

      <ModalComponent
        open={notificationDataModal}
        handleClose={() => {
          setNotificationDataModal(false);
          endProtectedAction();
        }}
        title={""}
        actions={<div className="HContainer j-center w-complete"></div>}
      >
        <Grid container className="mv-25 min-w-700">
          <Grid item xs={12} md={12}>
            <div className="VContainer j-center w-675">
              <p className="text-form-label" style={{ marginLeft: "10px" }}>
                Comentario:
              </p>
              <FormTextField
                name="coment"
                control={notificationControl}
                isTextArea={true}
                rows={2}
                disabled={true}
              />
            </div>
          </Grid>
        </Grid>
      </ModalComponent>
      <DeclineInspectionRecordModal
        onError={showInspectionError}
        onRejected={async (comments) => {
          setLoadDataState((current) => ({
            ...current,
            state: inspectionRecordProcess.pending,
            comments
          }));
          setIsEditable(false);
          setToastConfig({
            severity: "success",
            summary: "Acta rechazada",
            detail: "Acta de inspección devuelta con el comentario indicado."
          });
          setShowToast(true);
          await getBioEquipmentById();
        }}
        userId={userData.id}
        onStart={startRejection}
        onFinish={endRejection}
        open={openDeclineModal}
        close={handleCloseDeclineModal}
        bioEquipmentId={bioEquipmentId}
        inspectionRecordId={loadDataState.inspectionRecordId}
        comments={loadDataState.comments}
      />
      <ToastNotification
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
        showToast={showToast}
        setShowToast={setShowToast}
        position="top-right"
      />
    </div>
  );
};

export default NewTechnicalInspectionAct;
